<div class="portion-container" [class.alternate]="recipeDetailPage">
  <div
    class="title"
    *ngIf="!recipeDetailPage"
    [class.mobile]="platform === platformRef.mobile"
  >
    <p class="text-heading-preserved-margin">
      {{ 'i18n.menuProfitPro.recipeDetail.portion' | translate }}
    </p>
  </div>
  <div class="yield" [class.mobile]="platform === platformRef.mobile">
    <div class="label">
      <p class="text-body-preserved-margin">
        {{ 'i18n.menuProfitPro.recipeDetail.yield' | translate }}
      </p>
    </div>
    <div class="inputs">
      <ion-input
        class="input-standard input-numeric"
        [(ngModel)]="yield"
        [placeholder]="'-'"
        (ionBlur)="onYieldChange($event)"
        customDecimal
        [maxLeftHandDigits]="7"
        [maxPrecision]="2"
        [disabled]="lockEdits"
        inputmode="numeric"
        type="text"
        maxlength="10"
      ></ion-input>
      <ion-item
        id="portion-edit-yield-uom"
        data-cy="portion-edit-yield-uom-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        (click)="onShowYieldUOM($event)"
        [disabled]="lockEdits"
      >
        <ion-label
          class="text-body-preserved-margin"
          data-cy="portion-edit-detail-yield-uom-label"
          [class.text-gray]="yieldUOM === 'i18n.menuProfitPro.recipeDetail.cup'"
        >
          {{ yieldUOM | translate }}
        </ion-label>
      </ion-item>
    </div>
  </div>
  <div class="servingSize" [class.mobile]="platform === platformRef.mobile">
    <div class="label">
      <p class="text-body-preserved-margin">
        {{ 'i18n.menuProfitPro.recipeDetail.servingSize' | translate }}
      </p>
    </div>
    <div class="inputs">
      <ion-input
        class="input-standard input-numeric"
        [(ngModel)]="serving"
        [placeholder]="'-'"
        (ionBlur)="onServingChange($event)"
        customDecimal
        [maxLeftHandDigits]="5"
        [maxPrecision]="2"
        [disabled]="lockEdits"
        inputmode="numeric"
        type="text"
        maxlength="8"
      ></ion-input>
      <ion-item
        id="portion-edit-serving-uom"
        data-cy="portion-edit-serving-uom-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        (click)="onShowServingUOM($event)"
        [disabled]="lockEdits"
      >
        <ion-label
          class="text-body-preserved-margin"
          data-cy="portion-edit-serving-uom-label"
          [class.text-gray]="
            servingUOM === 'i18n.menuProfitPro.recipeDetail.cup'
          "
        >
          {{ servingUOM | translate }}
        </ion-label>
      </ion-item>
    </div>
  </div>
  <div
    class="servingPerRecipe"
    [class.mobile]="platform === platformRef.mobile"
  >
    <div class="label">
      <p class="text-body-preserved-margin">
        {{ 'i18n.menuProfitPro.recipeDetail.servingPerRecipe' | translate }}
      </p>
    </div>
    <div class="inputs">
      <ion-input
        class="input-standard input-numeric"
        [(ngModel)]="servingPerRecipe"
        [placeholder]="'-'"
        maxlength="4"
        numeric
        (ionBlur)="onServingPerRecipe($event)"
        [disabled]="lockEdits"
        inputmode="numeric"
        type="text"
      ></ion-input>
    </div>
  </div>
</div>
